"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HomeModel = /** @class */ (function () {
    function HomeModel() {
    }
    return HomeModel;
}());
exports.default = HomeModel;
//# sourceMappingURL=HomeModel.js.map